var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignItemsCenterVerticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.888 22.8888H12.5547V26.8888H9.88802V22.8888H0.554688V14.8888H9.88802V12.2222H4.55469V4.22217H9.88802V0.222168H12.5547V4.22217H17.888V12.2222H12.5547V14.8888H21.888V22.8888Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignItemsCenterVerticalIcon);
export default __webpack_public_path__ + "static/media/align-items-center-vertical-icon.0ffcb409486c681cef04668e6ea57b5b.svg";
export { ForwardRef as ReactComponent };